<div>
  <app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct && !this.isAmericanCitizen(this.application)"></app-protected-information>
  <div class="col-12 justify-content-center">

    <form #form="ngForm" (ngSubmit)="verifyProcess()">
      <div class="form-group text-center">
        <p>{{ "onboarding.add-referrer.add-referrer-code" | translate}}</p>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="referedCode" [value]="true" [(ngModel)]="application.hasReferredCode" #referredCode="ngModel" [ngClass]="inputFieldCss(referredCode, form)" required>
          <label class="form-check-label">{{ "onboarding.add-referrer.yes" | translate: {Default: "Sí"} }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="referedCode" (click)="application.body.altairParentAgentId = undefined; application.brokerCode = undefined;" [value]="false" [(ngModel)]="application.hasReferredCode" #referredCode="ngModel" [ngClass]="inputFieldCss(referredCode, form)" required>
          <label class="form-check-label">{{ "onboarding.add-referrer.no" | translate: {Default: "No"} }}</label>
        </div>
      </div>
      <div *ngIf="this.application.hasReferredCode"  class="row justify-content-center">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <input class="form-control" type="text" name="code" #code="ngModel"  [(ngModel)]="this.application.brokerCode" required>
            <p class="small m-0">{{ "onboarding.add-referrer.info" | translate: {Default: "Introduce el código aquí"} }}</p>
            <app-field-error-display [control]="code" [form]="form"></app-field-error-display>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-secondary float-left" type="button" (click)="onBack()" *ngIf="this.configurationService.application.sendBrokerScreenToEnd">{{ "onboarding.usa-ids.back" | translate: {Default: "Regresar"} }}</button>
          <button class="btn btn-primary mt-3" type="submit" [disabled]="!form.form.valid" (click)="displayContinue = true">{{ "onboarding.add-referrer.continue" | translate}}</button>
      </div>
    </form>
  </div>
  <!--Dialog to confirm referrer-->
  <p-dialog header=" " [(visible)]="displayConfirm" [modal]="true" [baseZIndex]="10000">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <i class="fas fa-exclamation-circle fa-2x notification-circle-icon"></i>
      <p>{{ "onboarding.add-referrer.confirm-broker" | translate}}</p>
      <p>{{validation?.name.toString().replaceAll('*','●')}}</p>
    </div>
    <div class="d-flex justify-content-between">
      <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayConfirm = false">{{ "onboarding.add-referrer.no" | translate}}</button>
      <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="confirmBroker(); displayConfirm = false">{{ "onboarding.add-referrer.yes" | translate}}</button>
    </div>
  </p-dialog>
  <!--Dialog to continue process-->
  <p-dialog header=" " [(visible)]="displayContinue" [modal]="true" [baseZIndex]="10000">
    <div class="d-flex align-items-center justify-content-center flex-column">
      <i class="fas fa-exclamation-triangle fa-2x notification-triangle-icon"></i>
      <p>{{ "onboarding.add-referrer.continue-no-code" | translate}}</p>
    </div>
    <div class="d-flex justify-content-between">
      <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayContinue = false">{{ "onboarding.add-referrer.no" | translate}}</button>
      <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="continueProcess(); displayContinue = false">{{ "onboarding.add-referrer.yes" | translate}}</button>
    </div>
  </p-dialog>
  <!--Dialog to notify invalid code-->
  <p-dialog header=" " [(visible)]="displayInvalidCode" [modal]="true" [baseZIndex]="10000">
    <div class="d-flex align-items-center justify-content-center flex-column">
      <i class="fas fa-exclamation-triangle fa-2x notification-triangle-icon"></i>
      <p *ngIf="!this.application.invalidReferredCode">{{ "onboarding.add-referrer.no-valid-code" | translate}}</p>
      <p *ngIf="this.application.invalidReferredCode && !this.configurationService?.application?.enforceAgentLinkCorrectness">{{ "onboarding.add-referrer.no-valid-url-code" | translate}}</p>
      <p *ngIf="this.application.invalidReferredCode && this.configurationService?.application?.enforceAgentLinkCorrectness">{{ "onboarding.add-referrer.no-valid-url-code-correctness-enforced" | translate}}</p>
    </div>
    <div class="d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary btn-width"  (click)="displayInvalidCode = false">{{ "onboarding.add-referrer.close" | translate}}</button>
    </div>
  </p-dialog>
  <!--Display Privacy Modal-->
  <p-dialog  header=" " [(visible)]="displayPrivacyModal" [modal]="true" [baseZIndex]="10000" [closable]="true" [breakpoints]="{'640px': '75vw'}" [style]="{ 'width': '40vw' }">
    <app-onboarding-privacy-modal (displayEvent)="displayPrivacyModal=$event"></app-onboarding-privacy-modal>
  </p-dialog>
</div>

